import { playersConstants } from './playersConstants';
import {userConstants} from "../../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  logItems: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "id",
  sortDirection: "desc",
  startDate: null,
  endDate: null,
  total: 0,
  logTotal: 0,
  error: '',
  query: "",
  inProgress: true,
});

export function player_exclusion_players(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case playersConstants.PLAYERS_LIST_REQUEST:
    case playersConstants.PLAYERS_LOAD_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        logTotal: 0,
        inProgress: true,
      };
    case playersConstants.PLAYERS_LIST_SUCCESS: {
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.players.rows ? action.players.rows : [],
        total: action.players.total ? action.players.total : 0,
        inProgress: false,
      };
    }
    case playersConstants.PLAYERS_LOAD_SUCCESS: {
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        logItems: action.players.rows ? action.players.rows : [],
        logTotal: action.players.total ? action.players.total : 0,
        inProgress: false,
      };
    }
    case playersConstants.PLAYERS_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case playersConstants.PLAYERS_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case playersConstants.PLAYERS_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.startDate !== action.pagination.startDate
        || state.endDate !== action.pagination.endDate
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        startDate: action.pagination.startDate,
        endDate: action.pagination.endDate,
        shouldReload
      };
    }

    case playersConstants.PLAYERS_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case playersConstants.PLAYERS_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.players],
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(t => t.id === action.players.id ? action.players : t)
      }
    case playersConstants.PLAYERS_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }
    default:
      return state
  }
}
